const atobImplementation = (b64Encoded: string) => {
    try {
        return atob(b64Encoded);
    } catch (err) {
        return Buffer.from(b64Encoded, 'base64').toString();
    }
};

export default atobImplementation;
